<template>
    <transition name='fade' mode="out-in">
        <div class="tooltip" :class="{'error': tooltip_type == 'error'}" v-if='show_tooltip'>
            {{tooltip_text}}
        </div>
    </transition>
</template>

<script>
export default {
    props: ['tooltip_queue'],
    data(){
        return{
            show_tooltip: false,
            tooltip_type: 'sucess'
        }
    },
    watch:{
        'tooltip_queue': {
            handler(){
                let item = this.tooltip_queue[this.tooltip_queue.length -1];
    
                this.tooltip_text = item.text;
                this.show_tooltip = true;

                if(typeof item.type !== 'undefined'){
                    this.tooltip_type = item.type;
                }
                else{
                    this.tooltip_type = 'success'; 
                }
                
                setTimeout(() => {
                    this.show_tooltip = false;
                }, 2000);
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.tooltip {
    position: absolute;
    padding: 20px 25px;
    color: #ffffff;
    background: var(--primary-colour);
    margin-top: 10px;
}

.tooltip:before {
    content: "";
    position: absolute;
    border-bottom: 15px solid var(--primary-colour);
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    top: 0;
    left: 45%;
    margin-left: -5px;
    margin-top: -7px;
}

.tooltip.error{
    background: #c92a2a;
}

.tooltip.error:before{
    border-bottom: 15px solid #c92a2a;
}
</style>